<template>
  <v-footer class="consumer-footer">
    <ul class="nav-items">
      <li class="nav-item">
        <a
          href="https://iwanthairdreams.com/policies/privacy-policy"
          class="link"
          >Privacy Policy</a
        >
      </li>
      <li class="nav-item">
        <a
          href="https://iwanthairdreams.com/policies/terms-of-service"
          class="link"
          >Terms of Service</a
        >
      </li>
      <li class="nav-item" to="/ccpa">
        <a href="/ccpa" class="link">CCPA Compliance</a>
      </li>
      <li class="nav-item">
        <a
          href="https://iwanthairdreams.com/pages/notice-of-collection-of-personal-information"
          class="link text-center"
          >Notice of Collection of Personal Information</a
        >
      </li>
      <li class="nav-item">
        <a href="http://find.hairdreams.com/salons" class="link text-center"
          >Current Partner Login</a
        >
      </li>
    </ul>
    <div class="copyright-box">
      <small class="copyright-content"
        >© {{ currentYear }},
        <a href="https://iwanthairdreams.com/" title="">Hairdreams</a></small
      >
    </div>
  </v-footer>
</template>

<script>
export default {
  name: 'ConsumerFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
  .consumer-footer {
    height: 200px;
    background-color: #f6f6f6;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    .nav-items {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-left: 0;

      .nav-item {
        list-style: none;
        margin-top: 5px;

        .link {
          text-align: left;
          text-decoration: none;
          display: inline-block;
          color: #454444;

          &:link {
            color: #454444;
          }
        }
      }
    }
    .copyright-box {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      .copyright-content {
        display: inline-block;

        a {
          text-decoration: none;
          color: #454444;
        }
      }
    }
  }
</style>
